let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("90x0x")).then(() => parcelRequire('35lDI'));